import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  FrontendFeature,
} from '@backstage/frontend-plugin-api';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { knowledgeGraphApiRef } from './api/KnowledgeGraphApi';
import { KnowledgeGraphClient } from './api/KnowledgeGraphClient';

const knowledgeGraphApi = ApiBlueprint.make({
  params: define =>
    define({
      api: knowledgeGraphApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new KnowledgeGraphClient({ fetchApi, discoveryApi }),
    }),
});

const knowledgeGraphPage = PageBlueprint.make({
  params: {
    path: '/knowledge-graph',
    title: 'Architecture',
    icon: <AccountTreeIcon />,
    loader: () =>
      import('./components/KnowledgeGraphStandalonePage').then(m => (
        <m.KnowledgeGraphStandalonePage />
      )),
  },
});

const knowledgeGraphEntityContent = EntityContentBlueprint.make({
  params: {
    path: 'architecture',
    title: 'Architecture',
    loader: () =>
      import('./components/KnowledgeGraphPage').then(m => (
        <m.KnowledgeGraphPage />
      )),
    filter: 'metadata.annotations.knowledge-graph.io/path',
  },
});

export const knowledgeGraphPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'knowledge-graph',
  extensions: [knowledgeGraphApi, knowledgeGraphPage, knowledgeGraphEntityContent],
});

export default knowledgeGraphPlugin;
